import AxiosFactory from '@/entities/security/AxiosFactory'
import {
  GET_CONTACT_INFO_URL,
  GET_INVOICE_URL,
  GET_INVOICE_PDF_URL,
  GET_CONTACT_VAT_URL,
} from '@/modules/invoice/endpoints'
import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import { PayByCreditPayloadI } from '@/modules/invoice/types/api/InvoiceItem'
import { GET_COUNTRIES_LIST_URL } from '../register/endpoints'

export default class InvoiceApi {
  async loadInvoice(id: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(GET_INVOICE_URL + `/${id}`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async loadContactInfo() {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(GET_CONTACT_INFO_URL)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async loadInvoiceUserDataInfo(id: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(GET_INVOICE_URL + `/${id}` + '/client-details')
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async loadCountryList() {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(GET_COUNTRIES_LIST_URL)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async loadContactVat() {
    try {
      return await AxiosFactory.createAxiosInstance().get(GET_CONTACT_VAT_URL)
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async payByCredit(payload: PayByCreditPayloadI) {
    try {
      const { id, amount } = payload
      await AxiosFactory.createAxiosInstance().post(GET_INVOICE_URL + `/${id}` + '/pay', {
        paymethod: 'applycredit',
        amount,
      })
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async loadInvoicePdf(id: number) {
    try {
      await AxiosFactory.createAxiosInstance()
        .get(`${GET_INVOICE_PDF_URL}/${id}/pdf`)
        .then(res => {
          const bytes = atob(res.data.pdfdata)
          const byteNumbers = new Array(bytes.length)
          for (let i = 0; i < bytes.length; i++) {
            byteNumbers[i] = bytes.charCodeAt(i)
          }
          const pdfByteArray = new Uint8Array(byteNumbers)
          const pdfBlob = new Blob([pdfByteArray], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(pdfBlob)
          const linkElement = document.createElement('a')
          linkElement.href = url
          linkElement.setAttribute('download', res.data.filename)
          document.body.appendChild(linkElement)
          linkElement.click()
        })
    } catch (e) {
      console.log('loadInvoicePdf error: ', e)
      throw ApiErrorFactory.create(e)
    }
  }
}
